var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviewSettings = function SvgPreviewSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3c1.306 0 2.418.835 2.83 2H21a1 1 0 1 1 0 2H10.83a3.001 3.001 0 0 1-5.66 0H3a1 1 0 0 1 0-2h2.17A3.001 3.001 0 0 1 8 3Zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8 15c1.306 0 2.418.835 2.83 2H21a1 1 0 1 1 0 2H10.83a3.001 3.001 0 0 1-5.66 0H3a1 1 0 1 1 0-2h2.17A3.001 3.001 0 0 1 8 15Zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM16 15a3.001 3.001 0 0 1-2.83-2H3a1 1 0 1 1 0-2h10.17a3.001 3.001 0 0 1 5.66 0H21a1 1 0 1 1 0 2h-2.17A3.001 3.001 0 0 1 16 15Zm0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: "#262D38",
    fillOpacity: 0.3
  })));
};
export default SvgPreviewSettings;